export const defaultReceiptConsentMessage =
  "I agree to Green Till's digital receipt Terms and Conditions.";

export const defaultReceiptSocialConfig = {
  facebook: true,
  twitter: true,
  google: true,
  instagram: true,
  linkedin: true,
  trustpilot: true,
  appStore: true,
  playStore: true,
  feedback: true,
  wallet: true,
  survey: false
};

export const socialPlatformMeta = [
  {
    key: "facebook",
    label: "Facebook",
    icon: "fab fa-facebook-f",
    color: "#1877F2"
  },
  {
    key: "twitter",
    label: "Twitter / X",
    icon: "fab fa-twitter",
    color: "#1DA1F2"
  },
  { key: "google", label: "Google", icon: "fab fa-google", color: "#EA4335" },
  {
    key: "instagram",
    label: "Instagram",
    icon: "fab fa-instagram",
    color: "#E4405F"
  },
  {
    key: "linkedin",
    label: "LinkedIn",
    icon: "fab fa-linkedin-in",
    color: "#0A66C2"
  },
  {
    key: "trustpilot",
    label: "Trustpilot",
    icon: "fas fa-star",
    color: "#00B67A"
  }
];

export const linkFieldByPlatform = {
  facebook: "facebookLink",
  twitter: "twitterLink",
  google: "googleLink",
  instagram: "instagramLink",
  linkedin: "linkedinLink",
  trustpilot: "trustpilotLink",
  appStore: "appStoreLink",
  playStore: "playStoreLink"
};

export function parseSocialConfig(raw) {
  if (!raw) return { ...defaultReceiptSocialConfig };
  if (typeof raw === "object") return { ...defaultReceiptSocialConfig, ...raw };
  try {
    return { ...defaultReceiptSocialConfig, ...JSON.parse(raw) };
  } catch (e) {
    return { ...defaultReceiptSocialConfig };
  }
}

export function buildPreviewReceiptData(values) {
  const socialConfig = parseSocialConfig(values.receiptSocialConfig);
  return {
    preview: true,
    storeName: values.name || values.storeName || "Your Store",
    storeLogo: values.image || values.storeLogo || null,
    receiptTagline: values.receiptTagline || "Thanks for shopping with us",
    consentMessage:
      values.receiptConsentMessage || defaultReceiptConsentMessage,
    receiptPrivacyText: values.receiptPrivacyText || "",
    receiptPrivacyPolicy: values.receiptPrivacyPolicy || "",
    primaryColor: values.primaryColor || "#1F3B6F",
    secondaryColor: values.secondaryColor || "#4CAF50",
    facebookLink: values.facebookLink,
    twitterLink: values.twitterLink,
    googleLink: values.googleLink,
    instagramLink: values.instagramLink,
    linkedinLink: values.linkedinLink,
    trustpilotLink: values.trustpilotLink,
    appStoreLink: values.appstoreLink || values.appStoreLink,
    playStoreLink: values.playstoreLink || values.playStoreLink,
    socialConfig,
    receiptPath: values.image || values.storeLogo || null,
    downloadUrl: "#",
    extension: "IMAGE",
    promotionalAdvertisementList: values.promotionalAdvertisementList || []
  };
}
